module.exports = __webpack_public_path__ + "images/emoji/arrow_left.4723d75f06993068f8a0.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/arrow_left.png
// module id = BL9O
// module chunks = 14